import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { animateScroll } from "react-scroll";
import { constructArtificialLinkNode, getStaticPageLink } from "../../../utils/links";
import { getImageLink } from "../../../utils/images";
import { decodeText, prepareRichText } from "../../../utils/richText";
import LinkWrapper from "../linkWrapper/LinkWrapper";
import Image from "../image/Image";

// Layout follows the corporate footer: brand column (logo, text, social icons from the Brands
// app) top-aligned with the link groups, the disclaimer in a bar at the bottom.
const Footer = ({ content, brand }) => {
    const [scroll, setScroll] = useState(0);
    const [top, setTop] = useState(0);

    const { linkGroups } = content;
    const text = prepareRichText(content.text);

    // brand.socials is a multi-field node; each entry carries an external link and an image.
    const socials =
        brand.socials && brand.socials["@nodes"]
            ? brand.socials["@nodes"]
                  .map((name) => brand.socials[name])
                  .filter((social) => social && social.link && getImageLink(social.image))
            : [];

    useEffect(() => {
        setTop(100);
        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    const scrollToTop = () => {
        animateScroll.scrollToTop();
    };

    const handleScroll = () => {
        setScroll(window.scrollY);
    };

    return (
        <footer className="footer-area bg-gray pt-100 pb-70">
            <div className="container">
                <div className="row">
                    <div className="col-lg-4 col-sm-12">
                        <div className="footer-brand mb-30">
                            {(brand.logo || brand.footerLogo) && (
                                <div className="footer-logo">
                                    <LinkWrapper linkNode={constructArtificialLinkNode({ value: getStaticPageLink("HOME") })}>
                                        <Image imageNode={brand.footerLogo ?? brand.logo} className="logo-img" />
                                    </LinkWrapper>
                                </div>
                            )}

                            {text && <div className="footer-brand__text" dangerouslySetInnerHTML={{ __html: text }} />}

                            {socials.length > 0 && (
                                <ul className="footer-brand__socials">
                                    {socials.map((social, idx) => (
                                        <li key={idx}>
                                            <a href={decodeText(social.link)} target="_blank" rel="noopener noreferrer">
                                                <Image imageNode={social.image} />
                                            </a>
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>
                    </div>

                    {linkGroups &&
                        linkGroups["@nodes"].map((nodeName) => (
                            <div key={nodeName} className="col-lg-2 col-sm-4 col-6">
                                <div className="footer-widget mb-30">
                                    <div className="footer-list">
                                        <ul>
                                            {linkGroups[nodeName]["@nodes"].map((fieldNodeName, idx) => {
                                                const field = linkGroups[nodeName][fieldNodeName];

                                                if (!field.label) return null;

                                                return (
                                                    <li key={fieldNodeName}>
                                                        {idx === 0 ? (
                                                            <div className="footer-title">
                                                                <h3>{decodeText(field.label)}</h3>
                                                            </div>
                                                        ) : (
                                                            <LinkWrapper linkNode={field}>{decodeText(field.label)}</LinkWrapper>
                                                        )}
                                                    </li>
                                                );
                                            })}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        ))}
                </div>

                {content.disclaimer && <p className="footer-disclaimer">{decodeText(content.disclaimer)}</p>}
            </div>

            <button className={`scroll-top ${scroll > top ? "show" : ""}`} onClick={() => scrollToTop()}>
                <i className="fa fa-angle-double-up"></i>
            </button>
        </footer>
    );
};

const mapStateToProps = (state) => ({
    brand: state.brandData,
});

export default connect(mapStateToProps)(Footer);
